export * from './BrandPageLazy';
export * from './BrandUpdatePageLazy';
